import axios from "axios";

const envUrl = process.env.REACT_APP_BACKEND_URL;
let baseUrl = envUrl;
try {
    if (typeof window !== "undefined" && envUrl && new URL(envUrl).host !== window.location.host) {
        baseUrl = window.location.origin;
    }
} catch {
    /* keep envUrl */
}

export const API = `${baseUrl}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("btf-token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export function fmtErr(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export function scrollToHash(hash) {
    const el = document.querySelector(hash);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el);
    else el.scrollIntoView({ behavior: "smooth" });
}
